import router from './index'
import staticsRoutes from './views'
const IndexComponent = () => import('@/pages/index/index.vue')
const LayoutComponent = () => import('@/pages/index/layout.vue')
const NotFound = () => import('@/pages/404.vue')

// 使用 import.meta.glob 预加载 views 目录下的所有 .vue 文件
const modules = import.meta.glob('@/views/**/*.vue', { eager: false })

let existingRoutes = []
const initUserRouters = menus => {
  staticsRoutes.forEach(route => {
    if (route.children && route.children.length) {
      existingRoutes = [...existingRoutes, ...route.children.map(x => route.path + '/' + x.path)]
    } else {
      existingRoutes.push(route.path)
    }
  })

  formatRoutes(menus).forEach(x => router.addRoute(x))
}

// 设置路由值
const getRouterPathValue = route => {
  return route.query.src ? route.query.src : route.path
}

const formatRoutes = (menus, parentName = '') => {
  if (menus.length === 0) return []
  const routerList = []
  for (let i = 0; i < menus.length; i++) {
    const menu = { ...menus[i] }
    const hasChildren = menu.children?.length > 0
    let path = menu.path
    if (!path) continue
    if (hasChildren && menu.children.some(x => x.path === menu.path)) {
      // 如果子菜单和父菜单path相同，则移除父菜单最后的部分
      path = path.substring(0, path.lastIndexOf('/'))
    }
    if (existingRoutes.includes(menu.path)) continue
    const isTopLevel = menu.parentId === '-1'
    // 规范化路径，确保以 / 开头
    const normalizedPath = menu.path.startsWith('/') ? menu.path : `/${menu.path}`
    const componentSrc = `/src/views${normalizedPath}.vue`

    // Create a unique name - if there's a parent name, prefix it to avoid conflicts
    let name = menu.label + menu.id
    // If this is a child route and has the same name as parent, make it unique
    if (parentName && name === parentName) {
      name = 'sub_' + name
    }

    const icon = menu.icon
    const meta = {
      title: menu.label,
      isAuth: true,
      keepAlive: Number(menu['keepAlive']) === 1
    }

    const getCurrentComponent = () => {
      if (isTopLevel) return IndexComponent // 顶层菜单返回Index
      if (hasChildren) return LayoutComponent // 多级菜单返回默认Layout
      // 使用 import.meta.glob 加载组件
      if (modules[componentSrc]) {
        return modules[componentSrc]
      } else {
        console.warn(`Component ${componentSrc} not found`)
        return NotFound
      }
    }

    let childRouters = []
    if (isTopLevel && !hasChildren) {
      // 顶级菜单没有子菜单的情况
      // 比如/ticket/index 需要拆分为2个部分，分别给父路由和子路由
      childRouters = [
        {
          component: modules[componentSrc] || NotFound,
          icon,
          name: 'child_' + name, // Add prefix to child route name to make it unique
          meta,
          path: path.substring(path.lastIndexOf('/') + 1)
        }
      ]
      path = path.substring(0, path.lastIndexOf('/'))
    } else if (hasChildren) {
      // Generate child routes recursively, passing current name to ensure uniqueness
      childRouters = formatRoutes(menu.children, name)
    }

    const route = {
      path: path,
      component: getCurrentComponent(),
      children: childRouters,
      name,
      icon,
      meta
    }
    routerList.push(route)

    if (isTopLevel) {
      // 添加到已有的路由，避免重复添加
      existingRoutes.push(route.path)
    }
  }
  return routerList
}

export default {
  initUserRouters,
  getRouterPathValue
}
